namespace $ {
	
	export const $giper_baza_flex_deck_link = new $giper_baza_link( 'AyiXyvOr_k8TaNSel_TkJWFugO' )
	
	/** Subj - named entity */
	export class $giper_baza_flex_subj extends $giper_baza_dict.with( {
		Name: $giper_baza_atom_text,
		Icon: $giper_baza_atom_text,
		Hint: $giper_baza_atom_text,
	}, 'Subj' ) {
		
		static meta = new $giper_baza_link( `${$giper_baza_flex_deck_link.str}_U2e5XejQ` )
		
		name( next?: string ) {
			return this.Name( next )?.val( next ) ?? this.link().str
		}
		
		icon( next?: string ) {
			return this.Icon( next )?.val( next ) ?? '💫'
		}
		
		hint( next?: string ) {
			return this.Hint( next )?.val( next ) ?? ''
		}
		
	}
	
	/** Atomic Link to any Subj */
	export class $giper_baza_flex_subj_link extends $giper_baza_atom_link_to( ()=> $giper_baza_flex_subj ) {}
	
	/** Meta - schema of entitiy */
	export class $giper_baza_flex_meta extends $giper_baza_flex_subj.with( {
		Pulls: $giper_baza_list_link_to( ()=> $giper_baza_flex_subj ),
		Props: $giper_baza_list_link_to( ()=> $giper_baza_flex_prop ),
	}, 'Meta' ) {
		
		static override meta = new $giper_baza_link( `${$giper_baza_flex_deck_link.str}_Atd6Ty7F` )
		
		@ $mol_action
		prop_new(
			key: string,
			type: string,
			kind?: $giper_baza_flex_meta,
			vars?: $giper_baza_list_vary,
			base?: $giper_baza_vary_type,
		) {
			const prop = this.Props(null)!.make( $mol_hash_string( key ) )
			
			prop.path( this.name() + ':' + key )
			prop.name( key )
			prop.type( type )
			
			if( kind ) prop.kind( kind )
			if( vars ) prop.enum( vars )
			if( base !== undefined ) prop.base( base )
			
			return prop
		}
		
		@ $mol_action
		prop_add( prop: $giper_baza_flex_prop ) {
			this.Props( prop )!.add( prop.link() )
		}
		
		@ $mol_mem
		prop_all(): readonly $giper_baza_flex_prop[] {
			return [
				... this.pull_all().flatMap( meta => meta.prop_all() ),
				... this.Props()?.remote_list() ?? [],
			]
		}
		
		@ $mol_action
		pull_add( meta: $giper_baza_flex_meta ) {
			this.Pulls( meta )!.add( meta.link() )
		}
		
		@ $mol_mem
		pull_all() {
			return ( this.Pulls()?.remote_list() ?? [] ).map( subj => subj.cast( $giper_baza_flex_meta ) )
		}
		
	}
	
	/** Property - attribute of entity */
	export class $giper_baza_flex_prop extends $giper_baza_flex_subj.with( {
		/** Key to store value */
		Path: $giper_baza_atom_text,
		/** Type of value */
		Type: $giper_baza_atom_text,
		/** Target Meta */
		Kind: $giper_baza_atom_link_to( () => $giper_baza_flex_meta ),
		/** Variants of values */
		Enum: $giper_baza_atom_link_to( () => $giper_baza_list_vary ),
		/** Base value */
		Base: $giper_baza_atom_vary,
	}, 'Prop' ) {
		
		static override meta = new $giper_baza_link( `${$giper_baza_flex_deck_link.str}_DOnW7Ah9` )
		
		path( next?: string ) {
			return this.Path( next )?.val( next ) ?? ''
		}
		
		type( next?: string ) {
			return this.Type( next )?.val( next ) ?? ''
		}
		
		base( next?: $giper_baza_vary_type ) {
			return this.Base( next )?.vary( next ) ?? null
		}
		
		kind( next?: $giper_baza_flex_meta ) {
			return this.Kind( next )?.remote( next ) ?? null
		}
		
		enum( next?: $giper_baza_list_vary ) {
			return this.Enum( next )?.remote( next ) ?? null
		}
		
	}
	
	/** Deck - set of schemes and types */
	export class $giper_baza_flex_deck extends $giper_baza_flex_subj.with( {
		Metas: $giper_baza_list_link_to( ()=> $giper_baza_flex_meta ),
		Types: $giper_baza_list_str,
	}, 'Deck' ) {
		
		static override meta = new $giper_baza_link( `${$giper_baza_flex_deck_link.str}_3AvnmQ4q` )
		
		@ $mol_action
		meta_new( key: string, icon: string, hint: string ) {
			const meta = this.Metas(null)!.make( $mol_hash_string( key ) )
			meta.name( key )
			meta.icon( icon )
			meta.hint( hint )
			return meta
		}
		
		@ $mol_action
		meta_for( Meta: typeof $giper_baza_flex_subj, icon: string, hint: string ) {
			const meta = this.meta_new( Meta.path, icon, hint )
			Meta.meta = meta.link()
			return meta
		}
		
	}
	
	/** Seed - global network config */
	export class $giper_baza_flex_seed extends $giper_baza_flex_subj.with( {
		Deck: $giper_baza_atom_link_to( ()=> $giper_baza_flex_deck ),
		Peers: $giper_baza_list_link_to( ()=> $giper_baza_flex_peer ),
	}, 'Seed' ) {
		
		static override meta = new $giper_baza_link( `${$giper_baza_flex_deck_link.str}_nrUK4ZIW` )
		
		@ $mol_mem
		deck() {
			return this.Deck(null)!.ensure( this.land() )
		}
		
		@ $mol_mem
		peers( next?: readonly $giper_baza_flex_peer[] ) {
			return this.Peers( next )?.remote_list( next ) ?? []
		}
		
	}
	
	/** Peer - network peering info */
	export class $giper_baza_flex_peer extends $giper_baza_flex_subj.with( {
		Urls: $giper_baza_list_str,
		Stat: $giper_baza_atom_link_to( ()=> $giper_baza_app_stat ),
	}, 'Peer' ) {
		
		static override meta = new $giper_baza_link( `${$giper_baza_flex_deck_link.str}_xEibvNCP` )
		
		@ $mol_mem
		stat( auto?: any ) {
			return this.Stat( auto )?.ensure( this.land() ) ?? null
		}
		
		@ $mol_mem
		urls( next?: string[] ) {
			return ( this.Urls( next )?.items( next ) ?? [] ).filter( $mol_guard_defined )
		}
		
	}
	
	type Point = readonly[ head: string, x: number, y: number ]
	type Selection = readonly [ from: Point, to: Point ]
	
	/** User - human profile */
	export class $giper_baza_flex_user extends $giper_baza_flex_subj.with( {
		Caret: $giper_baza_atom_list,
	}, 'User' ) {
		
		static override meta = new $giper_baza_link( `${$giper_baza_flex_deck_link.str}_csm0VtAK` )
		
		@ $mol_mem
		caret( next?: Selection ): Selection | null {
			return this.Caret( next )?.val( next ) as any as Selection ?? null
		}
		
	}
	
	/** Makes new Seed with Deck */
	export function $giper_baza_flex_init( this: $ ): $giper_baza_flex_seed {
			
		const seed_land = this.$.$giper_baza_glob.land_grab()
		const seed = seed_land.Data( $giper_baza_flex_seed )
		seed.name( 'Base Seed' )
		
		const deck = seed.deck()!
		deck.name( 'Base Deck' )
		deck.Types(null)!.items_vary([ 'vary', 'enum', 'bool', 'int', 'real', 'str', 'link', 'time', 'dict', 'text', 'list' ])
		
		const Meta = deck.meta_for( $giper_baza_flex_meta, '✨', 'Meta schema of entities' )
		Meta.meta( Meta.link() )
		
		const Subj = deck.meta_for( $giper_baza_flex_subj, '💎', 'Named entity' )
		const Seed = deck.meta_for( $giper_baza_flex_seed, '🌱', 'Seed of network' )
		const Prop = deck.meta_for( $giper_baza_flex_prop, '🔖', 'Property schema' )
		const Deck = deck.meta_for( $giper_baza_flex_deck, '📚', 'Collection of Metas' )
		const Peer = deck.meta_for( $giper_baza_flex_peer, '🔆', 'Peer of network' )
		const User = deck.meta_for( $giper_baza_flex_user, '👤', 'Profile of user' )
		
		seed.meta( Seed.link() )
		deck.meta( Deck.link() )
		
		Meta.pull_add( Subj )
		Seed.pull_add( Subj )
		Prop.pull_add( Subj )
		Deck.pull_add( Subj )
		Peer.pull_add( Subj )
		User.pull_add( Subj )
		
		Subj.prop_new( 'Name', 'str', undefined, undefined, '' )
		Subj.prop_new( 'Icon', 'str', undefined, undefined, '💫' )
		Subj.prop_new( 'Hint', 'str', undefined, undefined, '' )
		
		Meta.prop_new( 'Pulls', 'list', Meta, deck.Metas()! )
		Meta.prop_new( 'Props', 'list', Prop )
		
		Seed.prop_new( 'Deck', 'link', Deck )
		Seed.prop_new( 'Peers', 'list', Peer )
		
		Prop.prop_new( 'Path', 'str' )
		Prop.prop_new( 'Type', 'enum', undefined, deck.Types()!, 'vary' )
		Prop.prop_new( 'Kind', 'link', Meta, deck.Metas()!, Subj.link() )
		Prop.prop_new( 'Enum', 'link', Subj )
		Prop.prop_new( 'Base', 'vary', Subj )
		
		Deck.prop_new( 'Metas', 'list', Meta )
		Deck.prop_new( 'Types', 'list' )
		
		Peer.prop_new( 'Urls', 'list' )
		Peer.prop_new( 'Stat', 'link' )
		
		User.prop_new( 'Caret', 'list' )
		
		return seed
		
	}
	
}
